import React from 'react';
import PropTypes from 'prop-types';

const FocusableTrigger = ({children, className, onClick}) => {
  const preventClick = function(e) {
    if (e) {
      e.preventDefault();
    }

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <a
      className={className}
      href=""
      onClick={preventClick}
    >
      {children}
    </a>
  );
};

FocusableTrigger.PropTypes = {
  children:PropTypes.node,
  className:PropTypes.string,
  onClick:PropTypes.func,
};

export default FocusableTrigger;
